export default function Autocomplete(theme) {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: theme.shape.borderRadius,
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.primary.main,
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.primary.main,
              borderWidth: 2,
            },
          },
        },
        paper: {
          borderRadius: theme.shape.borderRadius,
          boxShadow: theme.shadows[4],
          marginTop: theme.spacing(1),
        },
        option: {
          borderRadius: theme.shape.borderRadius,
          margin: theme.spacing(0.5, 1),
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
          '&[aria-selected="true"]': {
            backgroundColor: theme.palette.action.selected,
          },
        },
      },
    },
  };
}

